class BlockedDisposableEmailDomains {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/blocked-disposable-email-domains`;

  }

  async blockDisposableEmailDomains(payload) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, payload);

  }

  async getBlockedDisposableEmailDomainsByQueryOptions(queryOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async deleteBlockedDomainById(blockedDomainId) {

    const path = `${this.basePath}/:blockedDomainId`;

    return this.apiClient.delete(path, { blockedDomainId }, {});

  }

}

export default BlockedDisposableEmailDomains;